import HTTP from '@/framework/utilities/http'
import querystring from 'querystring'

export default {
  bookAppointment ({ clientId, date, time, locationId }) {
    let query = {
      clientId: clientId,
      date: date,
      time: time,
      locationId: locationId
    }
    return HTTP.post('client/book-appointment', query)
  },

  createClient ({ firstName, lastName, email, phone, locationId }) {
    let query = {
      Id: null,
      FirstName: firstName,
      LastName: lastName,
      NickName: null,
      Phone: phone,
      Email: email,
      DateofBirth: null,
      PhoneType: 2,
      City: null,
      State: 'CA',
      ZipCode: null,
      ClientType: 0,
      Frequency: 14,
      Rate: 35,
      PortalEnabled: true,
      Acquisition: null,
      Status: 10,
      DefaultLocation: { Id: locationId },
      ReferralUserId: null,
      ReferralUserName: null
    }

    return HTTP.post('clients/add', query)
  },

  getClientLastPhoto ({ id }) {
    let query = {
      id: id
    }
    return HTTP.get(`client/photo?${querystring.stringify(query)}`)
  },

  getClientInformation ({ id }) {
    return HTTP.get(`clients/detail/${id}`)
  },

  getClientPreviousAppointments ({ id }) {
    return HTTP.get(`clients/previousappointments/${id}`)
  },

  getClientUpcomingAppointments ({ id }) {
    return HTTP.get(`clients/appointments/${id}`)
  },

  search ({ filter, limit, order, page }) {
    let query = {
      filter,
      limit: limit || 20,
      order: order || 'NameToLower',
      page: page || 1
    }

    return HTTP.get(`clients?${querystring.stringify(query)}`)
  },

  searchByPhone ({ phone }) {
    var query = {
      phoneNumber: phone
    }
    return HTTP.post('client/phone', query).then(res => {
      // fix if only one item. The service only returns an single
      // object if there is only one client for the query.
      // this is not a normal case
      if (res.data && !Array.isArray(res.data)) {
        res.data = [res.data]
      }

      return res
    })
  }
}
